module.exports = __webpack_public_path__ + "media/images/icons/arrow-left-circle-77cfd5d81e2c58e2800489b00d1d47a7.svg";